export enum RugbyUnionPenaltyTryAttribute {
  Golden = 1063,
}
